module.exports = __webpack_public_path__ + "img/crm-icon.c6c6753d.svg";